export class TimeZone {
    constructor(
        timeZoneId: number,
        timeZoneCode: string,
        year: number,
        dstStartLocalTime: Date | null,
        dstEndLocalTime: Date | null,
        utcOffset: number,
        utcOffsetDst: number
    ) {
        this.timeZoneId = timeZoneId;
        this.timeZoneCode = timeZoneCode;
        this.year = year;
        this.dstStartLocalTime = dstStartLocalTime;
        this.dstEndLocalTime = dstEndLocalTime;
        this.utcOffset = utcOffset;
        this.utcOffsetDst = utcOffsetDst;
    }
    timeZoneId: number;
    timeZoneCode: string;
    year: number;
    dstStartLocalTime: Date | null;
    dstEndLocalTime: Date | null;
    utcOffset: number;
    utcOffsetDst: number;
}
